export const TEAM_ANALYSIS = {
  path: 'team-analysis',
  name: 'teamAnalysis',
  component: () => import('@/views/recruiter/TeamAnalysisView.vue'),
  meta: {
    title: 'team_analysis.meta.title',
    permissions: ['talent_analysis']
  }
};
